import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function CaseStudiesCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-slate-950 border-t border-slate-800">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <AnimatedSection animation="fade-in">
          <div className="w-16 h-16 flex items-center justify-center bg-cyan-500/10 rounded-2xl mx-auto mb-6">
            <i className="ri-message-3-line text-cyan-400 text-3xl"></i>
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">
            {t('cs_cta_title')}
          </h2>
          <p className="text-slate-400 mb-10 text-lg">
            {t('cs_cta_desc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              {t('cs_cta_btn')}
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
